import Head from 'next/head';

export default function Contact() {
    return <div className="p-3 max-w-1300px m-auto">
        <Head>
            <title>Contact Us - CornHub</title>
        </Head>

        <h1 className="text-3xl font-bold">Contact Us</h1>

        <p>
            Whether you need support or would like to discuss a business opportunity, feel free to reach out using the
            contact methods below!
        </p>
        <p>
            E-Mail: <a className="text-primary underline"
                       href="mailto:contact@cornhub.website">contact@cornhub.website</a>
        </p>
        <p>
            Discord: <a className="text-primary underline" href="https://discord.gg/b3ZCsWkE2G" target="_blank"
                        rel="noreferrer">discord.gg/b3ZCsWkE2G</a>
        </p>
    </div>;
}
